var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.isVisibility,
          expression: "isVisibility",
        },
      ],
      attrs: { id: "base-pdf-renderer" },
    },
    [
      _c("div", { key: _vm.rendererTime, attrs: { id: "pdf-renderer" } }, [
        _c("div", { staticClass: "canvas-element" }, [
          _c("div", { staticClass: "exam-title" }, [_vm._v(_vm._s(_vm.title))]),
          _c("div", { staticClass: "exam-duration" }, [
            _vm._v(
              " " +
                _vm._s(_vm.examCode) +
                _vm._s(
                  _vm.$vuetify.lang.t(
                    "$vuetify.COURSE.BASE_PDF_QUESTION_RENDERRE.LABEL_TIME"
                  )
                ) +
                ": " +
                _vm._s(_vm.duration) +
                " " +
                _vm._s(
                  _vm.$vuetify.lang.t(
                    "$vuetify.COURSE.BASE_PDF_QUESTION_RENDERRE.TEXT_MINUTE"
                  )
                ) +
                " "
            ),
          ]),
        ]),
        _vm.parts.length
          ? _c(
              "div",
              _vm._l(_vm.parts, function (part, partIndex) {
                return _c(
                  "div",
                  { key: part.index + Date.now().toString() },
                  [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "font-weight": "medium",
                          "margin-left": "16px",
                          "margin-bottom": "8px",
                        },
                      },
                      [
                        _vm._v(
                          " Phần " +
                            _vm._s(part.index + 1) +
                            ": " +
                            _vm._s(part.title) +
                            " "
                        ),
                      ]
                    ),
                    _vm._l(part.questions, function (question, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "question-container" },
                        [
                          question.type === "direct-fill-blank-group"
                            ? _c(
                                "div",
                                [
                                  _c("QuestionDirectFillGroup", {
                                    attrs: { question: question, index: index },
                                  }),
                                ],
                                1
                              )
                            : _c("div", [
                                _c(
                                  "div",
                                  { staticClass: "question-overview" },
                                  [
                                    question.parentHtml
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "question-overview__parent",
                                          },
                                          _vm._l(
                                            question.parentHtml,
                                            function (element, i) {
                                              return _c(
                                                "div",
                                                {
                                                  key: "parent" + i,
                                                  staticClass:
                                                    "question-overview__description canvas-element-exam",
                                                  class: {
                                                    "is-last":
                                                      i ===
                                                      question.parentHtml
                                                        .length -
                                                        1,
                                                  },
                                                },
                                                [
                                                  i === 0
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "question-overview__parent-title",
                                                        },
                                                        [_vm._v("Câu hỏi nhóm")]
                                                      )
                                                    : _vm._e(),
                                                  _c("div", {
                                                    domProps: {
                                                      innerHTML:
                                                        _vm._s(element),
                                                    },
                                                  }),
                                                ]
                                              )
                                            }
                                          ),
                                          0
                                        )
                                      : _c(
                                          "div",
                                          _vm._l(
                                            question.description,
                                            function (element, i) {
                                              return _c(
                                                "div",
                                                {
                                                  key: "description" + i,
                                                  staticClass:
                                                    "question-overview__description canvas-element-exam",
                                                },
                                                [
                                                  i === 0
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "question-overview__title",
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm.$vuetify.lang.t(
                                                                  "$vuetify.COURSE.BASE_PDF_QUESTION_RENDERRE.LABEL_QUESTION"
                                                                )
                                                              ) +
                                                              " " +
                                                              _vm._s(
                                                                question.index +
                                                                  1
                                                              ) +
                                                              ": " +
                                                              _vm._s(
                                                                _vm.generateType(
                                                                  question.type
                                                                )
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _c("div", {
                                                    domProps: {
                                                      innerHTML:
                                                        _vm._s(element),
                                                    },
                                                  }),
                                                ]
                                              )
                                            }
                                          ),
                                          0
                                        ),
                                  ]
                                ),
                                question.type !== "group"
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "question-container__answer canvas-element-exam",
                                        class: {
                                          "is-last": question.isLastQuestion,
                                        },
                                      },
                                      [
                                        _c("Question", {
                                          attrs: {
                                            question: question,
                                            isCorrectHidden: "",
                                            isStudentAnswerCorrectShown: false,
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]),
                        ]
                      )
                    }),
                    partIndex !== _vm.parts.length - 1
                      ? _c("div", {
                          staticStyle: { "page-break-after": "always" },
                        })
                      : _vm._e(),
                  ],
                  2
                )
              }),
              0
            )
          : _c(
              "div",
              _vm._l(_vm.flattenQuestions, function (question, index) {
                return _c(
                  "div",
                  { key: index, staticClass: "question-container" },
                  [
                    question.type === "direct-fill-blank-group"
                      ? _c(
                          "div",
                          [
                            _c("QuestionDirectFillGroup", {
                              attrs: { question: question, index: index },
                            }),
                          ],
                          1
                        )
                      : _c("div", [
                          _c("div", { staticClass: "question-overview" }, [
                            question.parentHtml
                              ? _c(
                                  "div",
                                  { staticClass: "question-overview__parent" },
                                  _vm._l(
                                    question.parentHtml,
                                    function (element, i) {
                                      return _c(
                                        "div",
                                        {
                                          key: "parent" + i,
                                          staticClass:
                                            "question-overview__description canvas-element-exam",
                                          class: {
                                            "is-last":
                                              i ===
                                              question.parentHtml.length - 1,
                                          },
                                        },
                                        [
                                          i === 0
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "question-overview__parent-title",
                                                },
                                                [_vm._v("Câu hỏi nhóm")]
                                              )
                                            : _vm._e(),
                                          _c("div", {
                                            domProps: {
                                              innerHTML: _vm._s(element),
                                            },
                                          }),
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                )
                              : _c(
                                  "div",
                                  _vm._l(
                                    question.description,
                                    function (element, i) {
                                      return _c(
                                        "div",
                                        {
                                          key: "description" + i,
                                          staticClass:
                                            "question-overview__description canvas-element-exam",
                                        },
                                        [
                                          i === 0
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "question-overview__title",
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$vuetify.lang.t(
                                                          "$vuetify.COURSE.BASE_PDF_QUESTION_RENDERRE.LABEL_QUESTION"
                                                        )
                                                      ) +
                                                      " " +
                                                      _vm._s(
                                                        question.index + 1
                                                      ) +
                                                      ": " +
                                                      _vm._s(
                                                        _vm.generateType(
                                                          question.type
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _c("div", {
                                            domProps: {
                                              innerHTML: _vm._s(element),
                                            },
                                          }),
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                ),
                          ]),
                          question.type !== "group"
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "question-container__answer canvas-element-exam",
                                  class: { "is-last": question.isLastQuestion },
                                },
                                [
                                  _c("Question", {
                                    attrs: {
                                      question: question,
                                      isCorrectHidden: "",
                                      isStudentAnswerCorrectShown: false,
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]),
                  ]
                )
              }),
              0
            ),
      ]),
      _c("div", { attrs: { id: "pdf-renderer-temp" } }),
      _c("div", { attrs: { id: "description" } }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }